module.exports = __webpack_public_path__ + "static/media/entity.b1417172.svg";